import { NgModule, ModuleWithProviders } from '@angular/core';
import { NgxFfmComponent } from './ngx-ffm.component';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { NgxFfmConfig } from './ngx-ffm-config';
import { NGX_FFM_TOKEN } from './ngx-ffm-config.token';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SelectedFilesDialogComponent } from './components/dialogs/selected-files-dialog/selected-files-dialog.component';
import { FileActionsComponent } from './components/file-actions/file-actions.component';
import { FileDirectoriesComponent } from './components/file-directories/file-directories.component';
import { NewRegistrationDialogComponent } from '../lib/components/dialogs/new-registration-dialog/new-registration-dialog.component';



@NgModule({
  declarations: [NgxFfmComponent, ConfirmDialogComponent, SelectedFilesDialogComponent, FileActionsComponent, FileDirectoriesComponent, NewRegistrationDialogComponent],
  imports: [
    BrowserModule,
    MatIconModule,
    FlexLayoutModule,
    MatSortModule,
    MatTableModule,
    MatCheckboxModule,
    HttpClientModule,
    MatButtonModule,
    FormsModule,
    MatDialogModule,
    MatTooltipModule,
    MatInputModule,
    MatSnackBarModule,
    MatCardModule,
    MatProgressBarModule,
    MatMenuModule,
    MatSelectModule
  ],
  entryComponents: [
    ConfirmDialogComponent,
    SelectedFilesDialogComponent,
    NewRegistrationDialogComponent
  ],
  exports: [NgxFfmComponent, FileActionsComponent, FileDirectoriesComponent]
})
export class NgxFfmModule {
  static forRoot(ngxFileManagerConfig: NgxFfmConfig): ModuleWithProviders<NgxFfmModule> {
    return {
      ngModule: NgxFfmModule,
      providers: [
        {
          provide: NGX_FFM_TOKEN,
          useValue: ngxFileManagerConfig
        }
      ]
    };
  }
}
